import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-price",
  "use": "icon-price-usage",
  "viewBox": "0 0 14 13.98",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13.98\" id=\"icon-price\"><defs><style>#icon-price .cls-1{fill:#ff812c;}</style></defs><title>资源 71</title><g id=\"icon-price_图层_2\" data-name=\"图层 2\"><g id=\"icon-price_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M.88,0A.88.88,0,0,0,0,.88V6.62a.84.84,0,0,0,.26.62l6.48,6.48a.88.88,0,0,0,1.25,0L13.74,8a.88.88,0,0,0,0-1.25L7.26.26A.88.88,0,0,0,6.63,0Zm3.5,6.12A1.75,1.75,0,1,1,6.13,4.37,1.75,1.75,0,0,1,4.38,6.12Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol